import React, {useState, useEffect} from "react";
import {connect} from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
//import Button from 'react-bootstrap/Button'
import Button from '@material-ui/core/Button';
import { purple } from '@mui/material/colors';
import Form from 'react-bootstrap/Form'
import Spinner from 'react-bootstrap/Spinner';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import Modal from 'react-bootstrap/Modal';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import FormGroup from '@material-ui/core/FormGroup';
import IconButton from '@mui/material/IconButton';
import * as actions from "../store/actions";
import * as actionTypes from "../store/actions/actionTypes";

const useStyles = makeStyles((theme) => ({
    success: {
        backgroundColor: theme.palette.success.main,
        color: theme.palette.getContrastText(purple[500])
    },
    error: {
        backgroundColor: theme.palette.error.main
    }
}));

function QuickRenew(props) {

    const classes = useStyles();

    const [show, setShow] = useState(false);
    const [months, setMonths] = useState("");

    useEffect(() => {
        props.onInitializeRenewCredits();
    }, []);

    useEffect(() => {
        if (props.isFailRenewCredits){
            console.log('logging isfailretrieve credits', props.isFailRenewCredits);
            var errorMessage = '' + props.isFailRenewCredits;
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        }
    }, [props.isFailRenewCredits]);

    const spinner = (
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
        />
    );

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleSave = () => {
        console.log('logging months', months);
        const data = {
            name: props.name,
            months: months

        };
        console.log('logging data', data);
        props.onRenewCredits(props.token, data);
        setShow(false);
    };

    if(props.isSuccessRenewCredits){
        console.log('redirecting because', props.isSuccessRenewCredits);
        props.onGetCredits(props.token);
        props.onInitializeRenewCredits();
        props.onGetClientList(props.token, props.current_page);
        var successMessage = 'Renewed ' + props.isSuccessRenewCredits.months + ' month(s) for ' + props.isSuccessRenewCredits.name;
        props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_SUCCESS, message: successMessage});
    }
    //< AutorenewIcon onClick={handleShow} />
    function validateForm() {
        return months != 0;
    }

    //<Modal show={show} onHide={handleClose}>
    //    <Modal.Header closeButton>
    //        <Modal.Title>Renew {props.name}</Modal.Title>
    //    </Modal.Header>
    //    <Modal.Body>
    //        <Form>
    //            <Form.Group controlId="months">
    //                <Form.Control
    //                    as="select"
    //                    onChange={e => setMonths(e.target.value)}
    //                >
    //                    <option value={0}>Add months</option>
    //                    <option value={1}>1 Month</option>
    //                    <option value={2}>2 Months</option>
    //                    <option value={3}>3 Months</option>
    //                    <option value={4}>4 Months</option>
    //                    <option value={5}>5 Months</option>
    //                    <option value={6}>6 Months</option>
    //                    <option value={7}>7 Months</option>
    //                    <option value={8}>8 Months</option>
    //                    <option value={9}>9 Months</option>
    //                    <option value={10}>10 Months</option>
    //                    <option value={11}>11 Months</option>
    //                    <option value={12}>12 Months</option>
    //                </Form.Control>
    //            </Form.Group>
    //        </Form>
    //    </Modal.Body>
    //    <Modal.Footer>
    //        <Button variant="outlined" onClick={handleClose} color="secondary">
    //            Close
    //        </Button>
    //        <Button
    //            variant="outlined"
    //            color="primary"
    //            onClick={handleSave}
    //            disabled={!validateForm() || props.isLoadingRenewCredits}>
    //            Save Changes
    //        </Button>
    //    </Modal.Footer>
    //</Modal>

    //<Button variant="contained" startIcon={<AutorenewIcon />} size="small" onClick={handleShow} classes={{ root: classes.success }}>
    //Re
    //</Button>
    return (
        <>
            <IconButton size="small" onClick={handleShow} sx={{ padding: '0px' }}>
                <AutorenewIcon fontSize="small" />
            </IconButton>

            <Dialog
                open={show}
                onClose={handleClose}
                aria-labelledby="contained-modal-title-vcenter"
            >
                <DialogTitle id="form-dialog-title">Renew {props.name}</DialogTitle>

                <DialogContent>
                    <FormGroup>
                        <FormControl className={classes.formControl}>
                            <InputLabel id="select-months-label">Months</InputLabel>
                            <Select
                                id="months"
                                labelId="Select subscription"
                                onChange={e => setMonths(e.target.value)}
                            >
                                <MenuItem value={0}>Add months</MenuItem>
                                <MenuItem value={1}>1 Month</MenuItem>
                                <MenuItem value={2}>2 Months</MenuItem>
                                <MenuItem value={3}>3 Months</MenuItem>
                                <MenuItem value={4}>4 Months</MenuItem>
                                <MenuItem value={5}>5 Months</MenuItem>
                                <MenuItem value={6}>6 Months</MenuItem>
                                <MenuItem value={7}>7 Months</MenuItem>
                                <MenuItem value={8}>8 Months</MenuItem>
                                <MenuItem value={9}>9 Months</MenuItem>
                                <MenuItem value={10}>10 Months</MenuItem>
                                <MenuItem value={11}>11 Months</MenuItem>
                                <MenuItem value={12}>12 Months</MenuItem>
                            </Select>
                        </FormControl>
                    </FormGroup>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleSave}
                        disabled={!validateForm() || props.isLoadingRenewCredits}>
                        Save Changes
                    </Button>
                    <Button color="secondary" variant="outlined" onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        onRenewCredits: (token, data) => dispatch(actions.renewCredits(token, data)),
        onInitializeRenewCredits: () => dispatch(actions.initializeRenewCredits()),
        onGetCredits: (token) => dispatch(actions.creditsUser(token)),
        onGetClientList: (token, page) => dispatch(actions.clientList(token, page)),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message))

    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        current_page: state.clients.current_page,
        isSuccessRenewCredits: state.renewCredits.credits,
        isLoadingRenewCredits: state.renewCredits.loading,
        isFailRenewCredits: state.renewCredits.error
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(QuickRenew);